<template>
    <div class="detailstore">
        <div class="card">
            <van-field v-model="from.time" label="填表日期" readonly />
            <van-field v-model="from.userName" label="提报人姓名" readonly />
            <van-field v-model="from.phone" label="手机号" readonly />
            <!-- <van-field v-model="from.dept" label="部门" readonly /> -->
        </div>
        <div class="card">
            <van-field v-model="from.location" label="门店定位" readonly />
            <van-field v-model="from.dealerName" label="经销商" readonly />
            <van-field v-model="from.storeName" label="门店名称" readonly />
        </div>
        <div class="card">
            <!-- <van-field v-model="from.startTime" label="开始时间" readonly />
            <van-field v-model="from.endTime" label="结束时间" readonly /> -->
            <div>
                <p>照片</p>
                <div class="uploadImg">
                    <div class="imgbox" v-for="(item, index) in imgList" :key="index">
                        <img :src="item" class="carme" alt="" srcset="" @click="ImagePreviewcc(item)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast, ImagePreview } from 'vant';
import { getStoreDetail } from '../../apis/storeVisit'
export default {
    data() {
        return {
            from: {
                time:''
            },
            id: '',
            imgList: [],
        }
    },
    created() {
        console.log(this.$route)
        this.id = this.$route.query.id;
        this.getlist()
    },
    methods: {
        ImagePreviewcc(val){
            ImagePreview([val]);
        },
        getlist() {
            getStoreDetail(this.id).then(res => {
                this.from = res.data;
                this.from.time = this.timeChange(new Date(this.from.createTime))
                this.from.startTime = this.timeChange(new Date(res.data.startTime))
                this.from.endTime = this.timeChange(new Date(res.data.endTime))
                this.imgList = this.from.picUrl.split(',');
            })
        },
        /**
    * 时间转换
    */
        timeChange(val) {
            return `${val.getFullYear()}年${val.getMonth() + 1}月${val.getDate()}日`
        }
    },
}
</script>

<style lang="scss" scoped>
.detailstore {
    background-color: #F7F7F7;
    padding: 15px;
    text-align: left;

    .card {
        background-color: #fff;
        border-radius: 8px;
        padding: 8px;
        margin-bottom: 15px;

        .uploadImg {
            display: flex;
            flex-wrap: wrap;

            .imgbox {
                position: relative;
                margin-right: 10px;
                width: 30%;
            }
            .carme {
            width: 100%;
            height: 100px;
        }
        }
    }
}
</style>